import { create } from 'zustand';
import type { AnswerResult, AppConfig, CommonsStats, EmotionLabel, TrialStimulus } from './types';

interface AppState {
  config: AppConfig | null;
  deviceKey: string;
  deviceHashPreview: string | null;
  verified: boolean;
  trial: TrialStimulus | null;
  answer: AnswerResult | null;
  stats: CommonsStats | null;
  guess: {
    label: EmotionLabel | '';
    valence: number;
    arousal: number;
    confidence: number;
    startedAt: number;
  };
  error: string | null;
  setConfig: (config: AppConfig) => void;
  setDeviceKey: (deviceKey: string) => void;
  setVerified: (deviceHashPreview: string) => void;
  setTrial: (trial: TrialStimulus) => void;
  setAnswer: (answer: AnswerResult) => void;
  setStats: (stats: CommonsStats) => void;
  setGuess: (patch: Partial<AppState['guess']>) => void;
  setError: (error: string | null) => void;
  clearForNext: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  config: null,
  deviceKey: '',
  deviceHashPreview: null,
  verified: false,
  trial: null,
  answer: null,
  stats: null,
  guess: { label: '', valence: 0, arousal: 0, confidence: 70, startedAt: Date.now() },
  error: null,
  setConfig: (config) => set({ config }),
  setDeviceKey: (deviceKey) => set({ deviceKey }),
  setVerified: (deviceHashPreview) => set({ verified: true, deviceHashPreview }),
  setTrial: (trial) => set({ trial, answer: null, guess: { label: '', valence: 0, arousal: 0, confidence: 70, startedAt: Date.now() } }),
  setAnswer: (answer) => set({ answer }),
  setStats: (stats) => set({ stats }),
  setGuess: (patch) => set((state) => ({ guess: { ...state.guess, ...patch } })),
  setError: (error) => set({ error }),
  clearForNext: () => set({ trial: null, answer: null, error: null })
}));
